<template>
<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" id="nav-principal" href="http://www.apa-pablo-picasso.es">AMPA Pablo Picasso</a>
    </div>
  </nav>

  <!-- Paso 1 -->

  <div class="container py-3" v-if="paso == 1">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 1</h4>

    <form class="form-horizontal" id="form-paso1" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div v-if="! admin" class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Normas</h5>
      <div class="card-body">
        <ul>
          <li>La <b>cuota anual</b> de inscripción es de 15 euros por familia.</li>
          <li>Es imprescindible ser <b>socio del AMPA</b> para inscribirse a cualquier actividad extraescolar o evento del AMPA.</li>
          <li>El pago se hará preferentemente por <b>domiciliación bancaria</b>. Por favor, ten preparado tu número de cuenta antes de seguir.</li>
          <li>La <b>renovación anual</b> se podrá hacer desde la zona personal en la web, no siendo necesario rellenar de nuevo esa inscripción.</li>
        </ul>
      </div>
    </div>

	<div class="text-right">
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 2 -->

  <div class="container py-3" v-if="paso == 2">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 2</h4>

    <form class="form-horizontal" id="form-paso2" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Socio titular</h5>
      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-nombre">Nombre</label>
          <div class="col-md-5">
            <input id="titular-nombre" name="titular-nombre" type="text" v-model="datos.titular.nombre" class="form-control" :class="validarCampo(datos.titular.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-apellidos">Apellidos</label>
          <div class="col-md-5">
            <input id="titular-apellidos" name="titular-apellidos" type="text" v-model="datos.titular.apellidos" class="form-control" :class="validarCampo(datos.titular.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-relacion">Relación</label>
          <div class="col-md-5">
            <select class="select form-control" id="titular-relacion" name="titular-relacion" v-model="datos.titular.relacion" :class="validarCampo(datos.titular.relacion)" required>
              <option v-for="r in relaciones" :key="r" :value="r">{{ r }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el tipo de relación</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-nif">NIF</label>
          <div class="col-md-5">
            <input id="titular-nif" name="titular-nif" type="text" value="" class="form-control" v-model="datos.titular.nif" :class="validarCampo(validarNIF(datos.titular.nif) && nifTitularDisponible)">
            <div class="invalid-feedback" v-if="! nifTitularDisponible">Ya existe un socio con este NIF/NIE, no se puede dar de alta de nuevo</div>
            <div class="invalid-feedback" v-else>Introduce un NIF o NIE válido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-email">Email</label>
          <div class="col-md-5">
            <input id="titular-email" name="titular-email" type="text" value="" class="form-control" :class="validarCampo(validarEmail(datos.titular.email))" v-model="datos.titular.email" required>
            <div class="invalid-feedback">Debes introducir un email</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-domicilio">Domicilio</label>
          <div class="col-md-5">
            <input id="titular-domicilio" name="titular-domicilio" type="text" value="" class="form-control" v-model="datos.titular.domicilio">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-telefono1">Teléfono 1</label>
          <div class="col-md-5">
            <input id="titular-telefono1" name="titular-telefono1" type="text" value="" class="form-control" :class="validarCampo(validarTelefono(datos.titular.telefono1))" v-model="datos.titular.telefono1" required>
              <div class="invalid-feedback">Debes introducir al menos un teléfono válido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-telefono2">Teléfono 2</label>
          <div class="col-md-5">
            <input id="titular-telefono2" name="titular-telefono2" type="text" value="" class="form-control" v-model="datos.titular.telefono2">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="titular-observaciones">Observaciones</label>
          <div class="col-md-5">
            <textarea id="titular-observaciones" name="titular-observaciones" class="form-control" rows="3" v-model="datos.titular.observaciones"></textarea>
          </div>
        </div>

      </div>

    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 3 -->

  <div class="container py-3" v-if="paso == 3">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 3</h4>

    <form class="form-horizontal" id="form-paso3" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div v-if="! admin" class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Contraseña de acceso</h5>
      <div class="card-body">
        <p>Para acceder a tu área de socios deberás utilizar tu NIF y una contraseña de acceso que tú elijas:</p>

        <div class="form-group row">
          <label class="col-3 col-form-label" for="titular-password1">Contraseña</label>
          <div class="col-5">
            <input id="titular-password1" name="titular-password1" type="password" class="form-control" :class="validarCampo(datos.titular.password1)" v-model="datos.titular.password1" required>
            <div class="invalid-feedback">Debes introducir una contraseña</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-3 col-form-label" for="titular-password2">Contraseña (otra vez)</label>
          <div class="col-5">
            <input id="titular-password2" name="titular-password2" type="password" class="form-control" :class="validarCampo(validarPassword(datos.titular.password1, datos.titular.password2))" v-model="datos.titular.password2" required>
            <div class="invalid-feedback">Las dos contraseñas deben ser iguales</div>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 4 -->

  <div class="container py-3" v-if="paso == 4">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 4</h4>

    <form class="form-horizontal" id="form-paso4" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Persona autorizada (opcional)</h5>
      <div class="card-body">

        <p>Introduce los datos de otro adulto con autorización para acceder y realizar cambios</p>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-nombre">Nombre</label>
          <div class="col-md-5">
            <input id="autorizado-nombre" name="autorizado-nombre" type="text" v-model="datos.autorizado.nombre" class="form-control" :class="validarCampo(datos.autorizado.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-apellidos">Apellidos</label>
          <div class="col-md-5">
            <input id="autorizado-apellidos" name="autorizado-apellidos" type="text" v-model="datos.autorizado.apellidos" class="form-control" :class="validarCampo(datos.autorizado.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-relacion">Relación</label>
          <div class="col-md-5">
            <select class="select form-control" id="autorizado-relacion" name="autorizado-relacion" v-model="datos.autorizado.relacion" :class="validarCampo(datos.autorizado.relacion)" required>
              <option v-for="r in relaciones" :key="r" :value="r">{{ r }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el tipo de relación</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-nif">NIF</label>
          <div class="col-md-5">
            <input id="autorizado-nif" name="autorizado-nif" type="text" value="" class="form-control" v-model="datos.autorizado.nif" :class="validarCampo(validarNIF(datos.autorizado.nif) && nifAutorizadoDisponible)" required>
            <div class="invalid-feedback" v-if="! nifAutorizadoDisponible">Ya existe un socio con este NIF/NIE, no se puede dar de alta de nuevo</div>
            <div class="invalid-feedback" v-else>Introduce un NIF o NIE válido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-email">Email</label>
          <div class="col-md-5">
            <input id="autorizado-email" name="autorizado-email" type="text" value="" class="form-control" v-model="datos.autorizado.email" :class="validarCampo(validarEmail(datos.autorizado.email))" required>
            <div class="invalid-feedback">Debes introducir un email</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-domicilio">Domicilio</label>
          <div class="col-md-5">
            <input id="autorizado-domicilio" name="autorizado-domicilio" type="text" value="" class="form-control" v-model="datos.autorizado.domicilio">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-telefono1">Teléfono 1</label>
          <div class="col-md-5">
            <input id="autorizado-telefono1" name="autorizado-telefono1" type="text" value="" class="form-control" v-model="datos.autorizado.telefono1" :class="validarCampo(validarTelefono(datos.autorizado.telefono1))" required>
            <div class="invalid-feedback">Debes introducir al menos un teléfono válido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-telefono2">Teléfono 2</label>
          <div class="col-md-5">
            <input id="autorizado-telefono2" name="autorizado-telefono2" type="text" value="" class="form-control" v-model="datos.autorizado.telefono2">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="autorizado-observaciones">Observaciones</label>
          <div class="col-md-5">
            <textarea id="autorizado-observaciones" name="autorizado-observaciones" class="form-control" rows="3" v-model="datos.autorizado.observaciones"></textarea>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 5 -->

  <div class="container py-3" v-if="paso == 5">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 5</h4>

    <form class="form-horizontal" id="form-paso5" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Alumno 1 (requerido)</h5>
      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-nombre">Nombre</label>
          <div class="col-md-5">
            <input id="alumno1-nombre" name="alumno1-nombre" type="text" v-model="datos.alumno1.nombre" class="form-control" :class="validarCampo(datos.alumno1.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-apellidos">Apellidos</label>
          <div class="col-md-5">
            <input id="alumno1-apellidos" name="alumno1-apellidos" type="text" v-model="datos.alumno1.apellidos" class="form-control" :class="validarCampo(datos.alumno1.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-curso">Curso</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno1-curso" name="alumno1-curso" v-model="datos.alumno1.nivel" :class="validarCampo(datos.alumno1.nivel)" required>
              <option v-for="n in nivelesAlumnos" :key="n.id" :value="n.id">{{ n.nombre }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el curso del alumno</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-clase">Clase</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno1-clase" name="alumno1-clase" v-model="datos.alumno1.clase">
              <option v-for="c in clasesCursos" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-nacimiento">Fecha de nacimiento</label>
          <div class="col-md-5">
            <input id="alumno1-nacimiento" name="alumno1-nacimiento" type="text" v-model="datos.alumno1.nacimiento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" class="form-control" :class="validarCampo(validarFecha(datos.alumno1.nacimiento))" required>
            <div class="invalid-feedback">Debes indicar la fecha de nacimiento con formato dd/mm/aaaa</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno1-observaciones">Observaciones</label>
          <div class="col-md-5">
            <textarea id="alumno1-observaciones" name="alumno1-observaciones" class="form-control" rows="3" v-model="datos.alumno1.observaciones"></textarea>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
	</form>

  </div>

  <!-- Paso 6 -->

  <div class="container py-3" v-if="paso == 6">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 6</h4>

    <form class="form-horizontal" id="form-paso6" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Alumno 2 (opcional)</h5>
      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-nombre">Nombre</label>
          <div class="col-md-5">
            <input id="alumno2-nombre" name="alumno2-nombre" type="text" v-model="datos.alumno2.nombre" class="form-control" :class="validarCampo(datos.alumno2.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-apellidos">Apellidos</label>
          <div class="col-md-5">
            <input id="alumno2-apellidos" name="alumno2-apellidos" type="text" v-model="datos.alumno2.apellidos" class="form-control" :class="validarCampo(datos.alumno2.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-curso">Curso</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno2-curso" name="alumno2-curso" v-model="datos.alumno2.nivel" :class="validarCampo(datos.alumno2.nivel)" required>
              <option v-for="n in nivelesAlumnos" :key="n.id" :value="n.id">{{ n.nombre }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el curso del alumno</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-clase">Clase</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno2-clase" name="alumno2-clase" v-model="datos.alumno2.clase">
              <option v-for="c in clasesCursos" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-nacimiento">Fecha de nacimiento</label>
          <div class="col-md-5">
            <input id="alumno2-nacimiento" name="alumno2-nacimiento" type="text" v-model="datos.alumno2.nacimiento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" class="form-control" :class="validarCampo(validarFecha(datos.alumno2.nacimiento))" required>
            <div class="invalid-feedback">Debes indicar la fecha de nacimiento con formato dd/mm/aaaa</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno2-observaciones">Observaciones</label>
          <div class="col-md-5">
            <textarea id="alumno2-observaciones" name="alumno2-observaciones" class="form-control" rows="3" v-model="datos.alumno2.observaciones"></textarea>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
	</form>

  </div>

  <!-- Paso 7 -->

  <div class="container py-3" v-if="paso == 7">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 7</h4>

    <form class="form-horizontal" id="form-paso7" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Alumno 3 (opcional)</h5>
      <div class="card-body">

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-nombre">Nombre</label>
          <div class="col-md-5">
            <input id="alumno3-nombre" name="alumno3-nombre" type="text" v-model="datos.alumno3.nombre" class="form-control" :class="validarCampo(datos.alumno3.nombre)" required>
            <div class="invalid-feedback">Debes introducir un nombre</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-apellidos">Apellidos</label>
          <div class="col-md-5">
            <input id="alumno3-apellidos" name="alumno3-apellidos" type="text" v-model="datos.alumno3.apellidos" class="form-control" :class="validarCampo(datos.alumno3.apellidos)" required>
            <div class="invalid-feedback">Debes introducir al menos un apellido</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-curso">Curso</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno3-curso" name="alumno3-curso" v-model="datos.alumno3.nivel" :class="validarCampo(datos.alumno3.nivel)" required>
              <option v-for="n in nivelesAlumnos" :key="n.id" :value="n.id">{{ n.nombre }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar el curso del alumno</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-clase">Clase</label>
          <div class="col-md-5">
            <select class="select form-control" id="alumno3-clase" name="alumno3-clase" v-model="datos.alumno3.clase">
              <option v-for="c in clasesCursos" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-nacimiento">Fecha de nacimiento</label>
          <div class="col-md-5">
            <input id="alumno3-nacimiento" name="alumno3-nacimiento" type="text" v-model="datos.alumno3.nacimiento" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" class="form-control" :class="validarCampo(validarFecha(datos.alumno3.nacimiento))" required>
            <div class="invalid-feedback">Debes indicar la fecha de nacimiento con formato dd/mm/aaaa</div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label" for="alumno3-observaciones">Observaciones</label>
          <div class="col-md-5">
            <textarea id="alumno3-observaciones" name="alumno3-observaciones" class="form-control" rows="3" v-model="datos.alumno3.observaciones"></textarea>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
	</form>

  </div>

  <!-- Paso 8 -->

  <div class="container py-3" v-if="paso == 8">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 8</h4>

    <form class="form-horizontal" id="form-paso8" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Domiciliación bancaria</h5>
      <div class="card-body">

        <p>La cuenta bancaria debe estar a nombre del socio titular o de un autorizado</p>

        <div class="form-group row mt-4">
          <label class="col-md-2 col-form-label" for="domiciliacion-titular">Titular</label>
          <div class="col-md-5">
            <select class="select form-control" id="domiciliacion-titular" name="domiciliacion-titular" v-model="datos.domiciliacion.titular" :class="validarCampo(datos.domiciliacion.titular)" required>
              <option v-for="(t, index) in titularesCuenta()" :key="index" :value="t.persona">{{ t.nombre }}</option>
            </select>
            <div class="invalid-feedback">Debes indicar un titular de la cuenta</div>
          </div>
        </div>

        <div class="form-group row mt-4">
          <label class="col-md-2 col-form-label" for="numero-iban">IBAN</label>
          <div class="col-md-5">
            <input id="numbero-iban" name="numbero-iban" type="text" class="form-control" :class="validarCampo(validarIBAN(datos.domiciliacion.iban))" v-mask="'AA## #### #### #### #### ####'" v-model="datos.domiciliacion.iban" required>
            <div class="invalid-feedback">Debes introducir un IBAN español válido</div>
          </div>
        </div>

      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 9 -->

  <div class="container py-3" v-if="paso == 9">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 9</h4>

    <form class="form-horizontal" id="form-paso9" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Privacidad y permisos</h5>
      <div class="card-body">
        <p>El Ampa quiere enviar comunicaciones sobre eventos, próximas actividades y novedades por vía telemática. ¿Nos das permiso?</p>
        <div class="form-check">
          <input id="permiso-comunicacion-si" name="permiso-comunicacion" type="radio" class="form-check-input" value="si" v-model="datos.permComunicacion" :class="validarCampo(datos.permComunicacion != null)" required>
          <label class="form-check-label" for="permiso-comunicacion-si">Sí, QUIERO RECIBIR comunicaciones del AMPA sobre eventos, actividades y novedades de la asociación.</label>
        </div>
        <div class="form-check">
          <input id="permiso-comunicacion-no" name="permiso-comunicacion" type="radio" class="form-check-input" value="no" v-model="datos.permComunicacion" :class="validarCampo(datos.permComunicacion != null)" required>
          <label class="form-check-label" for="permiso-comunicacion-no">No, NO QUIERO RECIBIR comunicaciones del AMPA sobre eventos, actividades y novedades de la asociación.</label>
          <div class="invalid-feedback">Debes marcar una de las opciones</div>
        </div>
        <p></p>
        <p>El Ampa, durante sus eventos y actividades quiere realizar fotografías y videos para crear recuerdos del curso para compartir
        a las familias a final de curso. No son para Web ni RRSS. Necesitamos que también nos des tu consentimiento de imagen.</p>
        <div class="form-check">
          <input id="permiso-imagen-si" name="permiso-imagen" type="radio" class="form-check-input" value="si" v-model="datos.permImagen" :class="validarCampo(datos.permImagen != null)" required>
          <label class="form-check-label" for="permiso-imagen-no">Sí, doy mi permiso para que hagan fotos y video para crear recuerdo de curso. No se publicarán en RRSS.</label>
        </div>
        <div class="form-check">
          <input id="permiso-imagen-no" name="permiso-imagen" type="radio" class="form-check-input" value="no" v-model="datos.permImagen" :class="validarCampo(datos.permImagen != null)" required>
          <label class="form-check-label" for="permiso-imagen-no">No, NO QUIERO salir en las fotos y videos ni recibir dichas imágenes como recuerdo del curso.</label>
          <div class="invalid-feedback">Debes marcar una de las opciones</div>
        </div>

      </div>
    </div>

    <div v-if="! admin" class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Protección de datos</h5>
      <div class="card-body">
        <p>En virtud de lo que establece el REGLAMENTO (UE) 2016/679 relativo a la protección de datos de carácter personal de las
        personas físicas, le informamos que los datos aquí recogidos, serán gestionadas por la ASOCIACIÓN DE PADRES DEL
        COLEGIO PÚBLICO PABLO PICASSO con las siguientes finalidades propias y necesarias para el mantenimiento de la
        asociación: Gestión y desarrollo de las actividades y eventos, gestión de cobros y comunicación con los socios.</p>

        <p>Los datos proporcionados se conservarán mientras se mantenga la relación con nuestra Asociación o durante los años necesarios
        para cumplir con las obligaciones legales. Los datos no se cederán a terceros salvo en los casos en que exista una obligación
        legal.</p>

        <p>El responsable del tratamiento de los datos será la ASOCIACIÓN DE PADRES DEL COLEGIO PÚBLICO PABLO PICASSO.
        Si lo desea, puede llevar a cabo sus derechos de acceso, rectificación, supresión, limitación, oposición y
        portabilidad en todo momento escribiéndonos por correo postal a AMPA CEIP PABLO PICASSO (C/ Ángel Luis de la Herrán
        núm. 35, 28043 Madrid), o bien por email a juntadirectiva@apa-pablo-picasso.es, incluyendo la solicitud junto a la fotocopia
        de DNI del solicitante. Podéis encontrar más información en la web de Ampa.</p>
      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Siguiente</button>
    </div>
    </form>

  </div>

  <!-- Paso 10 -->

  <div class="container py-3" v-if="paso == 10">
    <h4 class="my-3">Inscripción de nuevo socio - Paso 10</h4>

    <form class="form-horizontal" id="form-paso10" action="" @submit.stop.prevent="completarPaso" novalidate>
    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Resumen</h5>
      <div class="card-body">
        <p><b>Titular:</b></p>
        <ul>
          <li><b>Nombre:</b> {{ datos.titular.nombre }} {{ datos.titular.apellidos }}</li>
          <li><b>Relación:</b> {{ datos.titular.relacion }}</li>
          <li><b>NIF:</b> {{ datos.titular.nif }}</li>
          <li><b>Email:</b> {{ datos.titular.email }}</li>
          <li><b>Teléfono 1:</b> {{ datos.titular.telefono1 }}</li>
          <li v-if="datos.titular.teléfono2"><b>Teléfono 2:</b> {{ datos.titular.telefono2 }}</li>
          <li v-if="datos.titular.domicilio"><b>Domicilio:</b> {{ datos.titular.domicilio }}</li>
          <li v-if="datos.titular.observaciones"><b>Observaciones:</b> {{ datos.titular.observaciones }}</li>
        </ul>
        <template v-if="datos.autorizado.nombre">
        <p><b>Autorizado:</b></p>
        <ul>
          <li><b>Nombre:</b> {{ datos.autorizado.nombre }} {{ datos.autorizado.apellidos }}</li>
          <li><b>Relación:</b> {{ datos.autorizado.relacion }}</li>
          <li><b>NIF:</b> {{ datos.autorizado.nif }}</li>
          <li><b>Email:</b> {{ datos.autorizado.email }}</li>
          <li><b>Teléfono 1:</b> {{ datos.autorizado.telefono1 }}</li>
          <li v-if="datos.autorizado.teléfono2"><b>Teléfono 2:</b> {{ datos.autorizado.telefono2 }}</li>
          <li v-if="datos.autorizado.domicilio"><b>Domicilio:</b> {{ datos.autorizado.domicilio }}</li>
          <li v-if="datos.autorizado.observaciones"><b>Observaciones:</b> {{ datos.autorizado.observaciones }}</li>
        </ul>
        </template>
        <p><b>Alumno 1:</b></p>
        <ul>
          <li><b>Nombre:</b> {{ datos.alumno1.nombre }} {{ datos.alumno1.apellidos }}</li>
          <li><b>Curso:</b> {{ datos.alumno1.nivel }} {{ datos.alumno1.clase }}</li>
          <li><b>Fecha de nacimiento:</b> {{ datos.alumno1.nacimiento }}</li>
          <li v-if="datos.alumno1.observaciones"><b>Observaciones:</b> {{ datos.alumno1.observaciones }}</li>
        </ul>
        <template v-if="datos.alumno2.nombre">
        <p><b>Alumno 2:</b></p>
        <ul>
          <li><b>Nombre:</b> {{ datos.alumno2.nombre }} {{ datos.alumno2.apellidos }}</li>
          <li><b>Curso:</b> {{ datos.alumno2.nivel }} {{ datos.alumno2.clase }}</li>
          <li><b>Fecha de nacimiento:</b> {{ datos.alumno2.nacimiento }}</li>
          <li v-if="datos.alumno2.observaciones"><b>Observaciones:</b> {{ datos.alumno2.observaciones }}</li>
        </ul>
        </template>
        <template v-if="datos.alumno3.nombre">
        <p><b>Alumno 3:</b></p>
        <ul>
          <li><b>Nombre:</b> {{ datos.alumno3.nombre }} {{ datos.alumno3.apellidos }}</li>
          <li><b>Curso:</b> {{ datos.alumno3.nivel }} {{ datos.alumno3.clase }}</li>
          <li><b>Fecha de nacimiento:</b> {{ datos.alumno3.nacimiento }}</li>
          <li v-if="datos.alumno3.observaciones"><b>Observaciones:</b> {{ datos.alumno3.observaciones }}</li>
        </ul>
        </template>
        <p><b>Forma de pago:</b></p>
        <ul>
          <li v-if="datos.domiciliacion.iban"><b>Domiciliación en cuenta:</b> {{ datos.domiciliacion.iban }}</li>
          <li v-else>No has introducido una cuenta bancaria. Podrás ponerla más adelante, o bien hacer los pagos por transferencia (no recomendado)</li>
        </ul>
      </div>
    </div>

    <div class="card mb-3">
      <h5 class="card-header bg-secondary text-white">Inscripción</h5>
      <div class="card-body">
        <div v-if="! admin" class="form-check">
          <input id="aceptar-normas" name="aceptar-normas" type="checkbox" class="form-check-input" v-model="datos.normas" :class="validarCampo(datos.normas)" required>
          <label class="form-check-label" for="aceptar-normas">Confirmo que los datos proporcionados son correctos, que he leído y acepto las normas y la política de privacidad, y autorizo el
          tratamiento de los datos de carácter personal anteriormente indicados</label>
          <div class="invalid-feedback">Debes marcar la casilla de confirmación</div>
        </div>
      </div>
    </div>

	<div class="text-right">
      <button type="button" class="btn btn-secondary mt-3" @click="pasoAtras()">Anterior</button>
      <button type="submit" class="btn btn-primary mt-3 ml-3">Enviar inscripción</button>
    </div>
    </form>

  </div>

</div>

</template>


<script>

import { api, guardarTokenApi } from '../api/api.js';
import {
	validarPassword,
	validarNIF,
	validarTelefono,
	validarEmail,
	validarFecha,
	validarIBAN,
} from '../validacion.js';

export default {
	name: 'Inscripcion',
	data() {
		return {
			admin: false,
            relaciones: [ 'padre', 'madre', 'abuelo', 'abuela', 'tutor' ],
            nivelesAlumnos: [
				{ 'id': 1, 'nombre': '1º Infantil' },
				{ 'id': 2, 'nombre': '2º Infantil' } , 
				{ 'id': 3, 'nombre': '3º Infantil' } , 
				{ 'id': 4, 'nombre': '1º Primaria' } , 
				{ 'id': 5, 'nombre': '2º Primaria' } , 
				{ 'id': 6, 'nombre': '3º Primaria' } , 
				{ 'id': 7, 'nombre': '4º Primaria' } , 
				{ 'id': 8, 'nombre': '5º Primaria' } , 
				{ 'id': 9, 'nombre': '6º Primaria' } ,
			],
            clasesCursos: [ 'A', 'B' ],
			datos: {
				titular: {
					nombre: null,
					apellidos: null,
					relacion: null,
					nif: null,
					domicilio: null,
					email: null,
					telefono1: null,
					telefono2: null,
					observaciones: null,
					password1: null,
					password2: null,
				},
				autorizado: {
					nombre: null,
					apellidos: null,
					relacion: null,
					nif: null,
					domicilio: null,
					email: null,
					telefono1: null,
					telefono2: null,
					observaciones: null,
				},
				alumno1: {
					nombre: null,
					apellidos: null,
					nivel: null,
					clase: null,
					nacimiento: null,
					observaciones: null,
				},
				alumno2: {
					nombre: null,
					apellidos: null,
					nivel: null,
					clase: null,
					nacimiento: null,
					observaciones: null,
				},
				alumno3: {
					nombre: null,
					apellidos: null,
					nivel: null,
					clase: null,
					nacimiento: null,
					observaciones: null,
				},
				domiciliacion: {
					titular: null,
					iban: null,
				},
				permComunicacion: null,
				permImagen: null,
				normas: null,
			},
			cacheNifDisponibles: {},
			nifTitularDisponible: true,
			nifAutorizadoDisponible: true,
			paso: 1,
			validacionPaso: {
				1: false,
				2: false,
				3: false,
				4: false,
				5: false,
				6: false,
				7: false,
				8: false,
				9: false,
				10: false,
			}
		}
	},
	watch: {
		// Si hemos marcado un NIF como no disponible en la API, en cuanto lo modificamos
		// queremos reiniciar la condición para que no siga diciendo que no está disponible
		'datos.titular.nif'() {
			this.nifTitularDisponible = true;
		},
		'datos.autorizado.nif'(nuevo) {
			if (nuevo == this.datos.titular.nif) {
				this.nifAutorizadoDisponible = false;
			} else {
				this.nifAutorizadoDisponible = true;
			}
		},
	},
	methods: {
		enviarInscripcion() {
			api(`/familias`, 'POST', this.datos)
				.then((data) => {
					this.familia = data.resultado.familia;
					guardarTokenApi(data.resultado.token);
					this.$router.push('/');
				})
				.catch((error) => {
					console.log(error);
				});
		},
		pasoAtras() {
			if (this.paso > 1) {
				this.paso -= 1;
				// next tick?
				window.scrollTo(0, 0);
			}
		},
		validarPassword,
		validarNIF,
		validarTelefono,
		validarEmail,
		validarFecha,
		validarIBAN,
		validarCampo(condicion) {
			if (! this.validacionPaso[this.paso]) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		async validarNIFDisponible(nif) {
			if (! (nif in this.cacheNifDisponibles)) {
				const data = await api(`/nif/${nif}`);
				this.cacheNifDisponibles[nif] = data.resultado;
			}
			return this.cacheNifDisponibles[nif];
		},
		titularesCuenta() {
			const titulares = [
				{
					persona: 'titular',
					nombre: `${this.datos.titular.nombre} ${this.datos.titular.apellidos}`,
				}
			];
			if (this.datos.autorizado.nombre && this.datos.autorizado.apellidos) {
				titulares.push({
					persona: 'autorizado',
					nombre: `${this.datos.autorizado.nombre} ${this.datos.autorizado.apellidos}`,
				});
			}
			return titulares;
		},
		async completarPaso(e) {
			let valido = true;
			let omitirPasos = 0;
			switch (this.paso) {
				case 1:
					// TODO: tal vez añadir un check para marcar
					break;
				case 2:
					valido = this.validarNIF(this.datos.titular.nif) &&
						this.validarEmail(this.datos.titular.email) &&
						this.validarTelefono(this.datos.titular.telefono1) &&
						e.target.checkValidity();
					if (valido) {
						this.nifTitularDisponible = await this.validarNIFDisponible(this.datos.titular.nif);
						valido = this.nifTitularDisponible;
					}
					break;
				case 3:
					valido = this.validarPassword(this.datos.titular.password1, this.datos.titular.password2) && e.target.checkValidity();
					break;
				case 4:
					if (this.datos.autorizado.nombre || this.datos.autorizado.apellidos) {
						valido = this.validarNIF(this.datos.autorizado.nif) && e.target.checkValidity();
						if (valido) {
							if (this.datos.autorizado.nif == this.datos.titular.nif) {
								this.nifAutorizadoDisponible = false;
							} else {
								this.nifAutorizadoDisponible = await this.validarNIFDisponible(this.datos.autorizado.nif);
							}
							valido = this.nifAutorizadoDisponible;
						}
					}
					break;
				case 5:
					valido = this.validarFecha(this.datos.alumno1.nacimiento) && e.target.checkValidity();
					break;
				case 6:
					if (this.datos.alumno2.nombre || this.datos.alumno2.apellidos) {
						valido = this.validarFecha(this.datos.alumno2.nacimiento) && e.target.checkValidity();
					} else {
						omitirPasos = 1;
					}
					break;
				case 7:
					if (this.datos.alumno3.nombre || this.datos.alumno3.apellidos) {
						valido = this.validarFecha(this.datos.alumno3.nacimiento) && e.target.checkValidity();
					}
					break;
				case 8:
					if (this.datos.domiciliacion.iban) {
						valido = this.validarIBAN(this.datos.domiciliacion.iban) && e.target.checkValidity();
					}
					break;
				case 9:
					valido = this.datos.permImagen != null && this.datos.permComunicacion != null
					break;
				case 10:
					valido = this.datos.normas;
					break;
			}

			if (! valido) {
				this.validacionPaso[this.paso] = true;
				window.scrollTo(0, 0);
				return;
			}

			this.validacionPaso[this.paso] = false;

			if (this.paso == 10) {
				this.enviarInscripcion();
			} else {
				this.paso += 1 + omitirPasos;
				// next tick?
				window.scrollTo(0, 0);
			}
		},
	}
}
</script>
